
import { Box } from "@twilio-paste/core/box";
import { TextArea } from "@twilio-paste/core/textarea";
import { FormEvent } from "react";
import { Button } from "@twilio-paste/core/button";
import { useDispatch, useSelector } from "react-redux";
import { Text } from "@twilio-paste/core/text";
import { Flex } from "@twilio-paste/core/flex";
import { UserIcon } from "@twilio-paste/icons/esm/UserIcon";

import { sessionDataHandler } from "../sessionDataHandler";
import { addNotification, changeEngagementPhase, updatePreEngagementData } from "../store/actions/genericActions";
import { initSession } from "../store/actions/initActions";
import { AppState, EngagementPhase } from "../store/definitions";
import { Header } from "./Header";
import { notifications } from "../notifications";
import { NotificationBar } from "./NotificationBar";
import { formStyles } from "./styles/PreEngagementFormPhase.styles";
import {
    getAvatarContainerStyles,
    getInnerContainerStyles,
    authorStyles,
    bodyStyles,
    bubbleAndAvatarContainerStyles
} from "./styles/MessageBubble.styles";


export const PreEngagementFormPhase = () => {
    const { query } = useSelector((state: AppState) => state.session.preEngagementData) || {};
    const { sessionData } = useSelector((state: AppState) => state.config) || {};
    const dispatch = useDispatch();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        dispatch(changeEngagementPhase({ phase: EngagementPhase.Loading }));
        try {
            const data = await sessionDataHandler.fetchAndStoreNewSession({
                formData: {
                    friendlyName: "Customer",
                    query,
                    ...sessionData
                }
            });
            dispatch(initSession({ token: data.token, conversationSid: data.conversationSid }));
        } catch (err) {
            dispatch(addNotification(notifications.failedToInitSessionNotification((err as Error).message)));
            dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const belongsToCurrentUser = true;

    return (
        <>
            <Header />
            <NotificationBar />
            <Box as="form" data-test="pre-engagement-chat-form" onSubmit={handleSubmit} {...formStyles}>
                <Box {...bubbleAndAvatarContainerStyles}>
                    {!belongsToCurrentUser && (
                        <Box {...getAvatarContainerStyles(true)} data-testid="avatar-container">
                            {belongsToCurrentUser && <UserIcon decorative={true} size="sizeIcon40" />}
                        </Box>
                    )}
                    <Box {...getInnerContainerStyles(belongsToCurrentUser)}>
                        <Flex hAlignContent="between" width="100%" vAlignContent="center" marginBottom="space20">
                            <Text
                                {...authorStyles}
                                as="p"
                                aria-hidden
                                style={{ textOverflow: "ellipsis" }}
                                title="BKV Energy"
                            >
                                {"BKV Energy"}
                            </Text>
                            {/* <Text {...timeStampStyles} as="p">
                                {new Date()}
                            </Text> */}
                        </Flex>
                        <Text as="p" {...bodyStyles}>
                            Welcome to BKV Energy! Type `Hello` or `Hi` to start the chat.
                        </Text>
                    </Box>
                </Box>
                <Box {...formStyles}>
                    <TextArea
                        placeholder="Your message"
                        name="query"
                        data-test="pre-engagement-chat-form-query-textarea"
                        value={query}
                        onChange={(e) => dispatch(updatePreEngagementData({ query: e.target.value }))}
                        onKeyPress={handleKeyPress}
                        required
                    />
                </Box>

                <Button variant="primary" type="submit" data-test="pre-engagement-start-chat-button">
                    Start chat
                </Button>
            </Box>
        </>
    );
};
